module.exports = __webpack_public_path__ + "img/Petroleum_logo.29b90c9c.jpg";